import { ApplicationState } from '~/store/store';

export const getEquipmentState = (state: ApplicationState) => state.equipment;
